import React, { useRef, useEffect } from "react";
import debounce from "lodash/debounce";
import useDidMountEffect from "shared/hooks/use_did_mount_effect";
var Tooltip = function (props) {
    var tagRef = useRef({});
    var shownOnKeepOpen = useRef(false);
    useEffect(function () {
        var jQTagRef = $(tagRef.current);
        var tooltipContainer = props.container || $("body");
        if (props.keepTooltipOpenOnHover) {
            tooltipContainer = jQTagRef;
        }
        if (props.title) {
            jQTagRef.tooltip({
                html: props.allowDangerousHtml === "ilikedanger",
                container: tooltipContainer,
                placement: props.placement || "bottom",
                title: props.title,
                trigger: props.keepTooltipOpenOnHover || props.displayManually
                    ? "manual"
                    : "hover"
            });
            if (props.keepTooltipOpenOnHover) {
                document
                    .getElementsByTagName("body")[0]
                    .addEventListener("mouseover", _bodyOnMouseOver);
            }
        }
        if (props.displayManually && props.displayed) {
            // manually display it
            jQTagRef.tooltip("show");
        }
        // clean up function, like componentWillUnmount
        return function () {
            if (props.keepTooltipOpenOnHover) {
                // must remove the body event listener
                document
                    .getElementsByTagName("body")[0]
                    .removeEventListener("mouseover", _bodyOnMouseOver);
            }
            if (props.displayManually) {
                var jQTagRef_1 = $(tagRef.current);
                jQTagRef_1.tooltip("hide");
            }
        };
    }, []);
    // This is used only when the component props update
    useDidMountEffect(function () {
        if (props.displayManually) {
            var jQTagRef = $(tagRef.current);
            if (!props.displayed) {
                //manually hide it
                jQTagRef.tooltip("hide");
            }
            else {
                // manually display it
                jQTagRef.tooltip("show");
            }
        }
    }, [props.displayed]);
    /**
     * This is used only when the prop "keepTooltipOpenOnHover" is true
     */
    var _onParentMouseOver = function (e) {
        if (props.keepTooltipOpenOnHover && !shownOnKeepOpen.current) {
            var jQTagRef = $(tagRef.current);
            jQTagRef.tooltip("show");
            shownOnKeepOpen.current = true;
        }
    };
    /**
     * This is used only when the prop "keepTooltipOpenOnHover" is true, and is executed when the mouse hovers the screen
     * It's needed to check if the tooltip must be hide
     */
    var _bodyOnMouseOver = function (e) {
        if (shownOnKeepOpen.current) {
            _bodyMouseOverDebounce(e.target);
        }
    };
    var _bodyMouseOverDebounce = debounce(function (target) {
        if (shownOnKeepOpen.current) {
            if (!tagRef.current.contains(target)) {
                var jQTagRef = $(tagRef.current);
                jQTagRef.tooltip("hide");
                shownOnKeepOpen.current = false;
            }
        }
    }, 50);
    // define the Tag type: div or something else from props
    var ParentTag = props.tag || "div";
    var combinedClassName = "".concat(props.className, " ").concat(props.selectableTextInTooltip ? "selectable-tooltip-text" : "");
    return props.title ? (React.createElement(ParentTag, { ref: tagRef, className: combinedClassName, onMouseOver: _onParentMouseOver }, props.children)) : (props.forceContent ? React.createElement(React.Fragment, null, props.children) : null);
};
Tooltip.defaultProps = {
    tag: "div",
    placement: "bottom",
    displayManually: false,
    displayed: false,
    forceContent: false
};
export default Tooltip;
try {
    // @ts-ignore
    tooltip.displayName = "tooltip";
    // @ts-ignore
    tooltip.__docgenInfo = { "description": "", "displayName": "tooltip", "props": { "tag": { "defaultValue": { value: "div" }, "description": "The type of HTML tag this component will output", "name": "tag", "required": false, "type": { "name": "\"div\" | \"span\" | \"li\"" } }, "className": { "defaultValue": null, "description": "Custom class name for the element", "name": "className", "required": false, "type": { "name": "string" } }, "selectableTextInTooltip": { "defaultValue": null, "description": "Set this to true and user will bea ble to select the text in tooltip", "name": "selectableTextInTooltip", "required": false, "type": { "name": "boolean" } }, "title": { "defaultValue": null, "description": "Actual text displayed in tooltip", "name": "title", "required": true, "type": { "name": "string" } }, "keepTooltipOpenOnHover": { "defaultValue": null, "description": "", "name": "keepTooltipOpenOnHover", "required": false, "type": { "name": "boolean" } }, "forceContent": { "defaultValue": { value: false }, "description": "", "name": "forceContent", "required": false, "type": { "name": "boolean" } }, "container": { "defaultValue": null, "description": "Container of the tooltip element (it's a DOM element), by default it's the body", "name": "container", "required": false, "type": { "name": "any" } }, "placement": { "defaultValue": { value: "bottom" }, "description": "Where to show the tooltip relative to the child element", "name": "placement", "required": false, "type": { "name": "\"top\" | \"right\" | \"bottom\" | \"left\"" } }, "displayManually": { "defaultValue": { value: false }, "description": "If we'll manually show/hide the tooltip", "name": "displayManually", "required": false, "type": { "name": "boolean" } }, "allowDangerousHtml": { "defaultValue": null, "description": "If we renderHTML in tooltip", "name": "allowDangerousHtml", "required": false, "type": { "name": "\"ilikedanger\"" } }, "displayed": { "defaultValue": { value: false }, "description": "Used together with `displayManually`, it's the manual/external state of the tooltip", "name": "displayed", "required": false, "type": { "name": "boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["app/javascript/shared/components/tooltip.tsx#tooltip"] = { docgenInfo: tooltip.__docgenInfo, name: "tooltip", path: "app/javascript/shared/components/tooltip.tsx#tooltip" };
}
catch (__react_docgen_typescript_loader_error) { }
